import React from 'react';
import Tooltip from '../../tooltiped/Tooltip';
// import X from '../../icons/X';
// import Check from '../../icons/Check';

export interface INavButtonsData {
    label: string;
    tooltip?: string;
    prev: boolean;
    next: boolean;
    onClick?: () => void;
    onClick2?: () => void;
    onPrev?: () => void;
    onNext?: () => void;
}

const NavButtons = (props: INavButtonsData) => {
    const { label, tooltip, prev, next, onClick, onClick2, onPrev, onNext } = props;

    const labels = label.split('|');

    const button1 = (
        <button onClick={onClick} className={`Container w-[-webkit-fill-available] h-10 px-3 bg-buttons-primary rounded-lg flex flex-1 justify-center items-center gap-2.5 disabled:opacity-50 disabled:pointer-events-none`}>
            <div className="flex-1 text-center justify-start text-text-dark-invert text-sm font-semibold font-['Inter'] leading-tight">{labels[0]}</div>
        </button>
    );

    return (
        <div className="w-full h-10 py-3 rounded-lg inline-flex justify-start items-center gap-2.5 overflow-hidden">
            {onPrev && <button onClick={onPrev} disabled={prev} className={`flex-1 max-w-10 h-10 px-3 bg-buttons-${prev ? 'inactive' : 'primary'} rounded-lg flex justify-center items-center gap-2.5 disabled:opacity-50 disabled:pointer-events-none`}>
                <div className="relative">
                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.3203 4.04297L7.32031 12.043L17.3203 20.043" stroke="var(--color-brand-icon-light, white)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
            </button>}
            {tooltip ? <Tooltip text={tooltip} className="w-[-webkit-fill-available] items-center justify-center" textStyling="z-10 max-w-[250px] whitespace-break-spaces">{button1}</Tooltip> : button1}
            {onClick2 && <button onClick={onClick2} className="Container w-56 h-10 px-3 bg-buttons-onState rounded-lg flex justify-center items-center gap-2.5 disabled:opacity-50 disabled:pointer-events-none">
                <div className="flex-1 text-center justify-start text-text-dark-invert text-sm font-semibold font-['Inter'] leading-tight">{labels[1]}</div>
            </button>}
            {onNext && <button onClick={onNext} disabled={next} className={`flex-1 max-w-10 h-10 px-3 bg-buttons-${next ? 'inactive' : 'primary'} rounded-lg flex justify-center items-center gap-2.5 disabled:opacity-50 disabled:pointer-events-none`}>
                <div className="relative">
                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.82031 20.043L17.8203 12.043L7.82031 4.04297" stroke="var(--color-brand-icon-light, white)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
            </button>}
        </div>
    );
};

export default NavButtons;